import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { advisorOnboardingApi } from '@client/api/waterlily';

export function useSendTwoPagerEmail(advisorId: string) {
  const mutation = useMutation({
    mutationFn: () => advisorOnboardingApi.sendTwoPager(advisorId),
    onSuccess: () => {
      toast.success('Your two-pager is on the way', {
        description: 'It will arrive in your inbox shortly.',
      });
    },
    onError: error => {
      toast.error("We couldn't send your two-pager", {
        description: error instanceof Error ? error.message : 'Please try again.',
      });
    },
  });

  return {
    sendTwoPager: mutation.mutate,
    isSendingTwoPager: mutation.isPending,
  };
}
